import Vue from 'vue'
import Button from '../BaseButton/BaseButton.vue'
export default Vue.extend({
    name: 'Pagination',
    components: {
        Button
    },
    props: {
        slides: Array,
    },
    data() {
        return {
            active_slide: 1,
        }
    }
})